import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import OurServiceCardContainer from "../OurServices/OurServiceCardContainer";

const BeneficariesView = ({ title, features, benefits }) => {
  return (
    <>
      <UpdatesBanner className="pnbg text-white" bannerTitle={title} />
      <OurServiceCardContainer services={features} title="Features" />
      <div className="main-wrapper">
        <OurServiceCardContainer services={benefits} title="Benefits" />
      </div>
    </>
  );
};

export default BeneficariesView;
